import { useContext } from 'react';
import { BuildInAppToolId, IAppToolsContext } from '../types/appTools';
import AppToolsContext from '../context/AppToolsContext';
import {
    useActivitiesLiveStatus,
    useEvent,
    useSession,
    useVirtualSession,
} from '@bizzabo/entities';
import useWaitingRoom from '../../agenda/hooks/waitingRoom';
import { useEnabledAppTools } from '../../tools/decorators/useEnabledAppTools';

export const isEngagementAppEnabled = (
    session,
    virtualSession,
    activitiesLiveStatus,
    isWaitingRoomActive
) => {
    const virtualSessionError = virtualSession.isLoading || virtualSession.isError;

    if (virtualSessionError) {
        return false;
    }

    const isExtensionActive = !!session.data?.engagements?.[0]?.extensionId;
    const isCollaborationActive =
        !!activitiesLiveStatus.data?.[session.data?.id]?.isCollaborationActive;

    return isExtensionActive && (isCollaborationActive || isWaitingRoomActive);
};

const EngagementAppEnabled = ({ children }) => {
    const { eventUniqueName, sessionId } = useContext<IAppToolsContext>(AppToolsContext);
    const event = useEvent(eventUniqueName);
    const session = useSession(event.data?.id, sessionId);
    const virtualSession = useVirtualSession({
        eventId: event.data?.id,
        sessionId: sessionId,
    });

    const { isActive: isWaitingRoomActive } = useWaitingRoom(eventUniqueName, sessionId);

    const activitiesLiveStatus = useActivitiesLiveStatus(eventUniqueName);

    const isLoading =
        event.isLoading ||
        session.isLoading ||
        virtualSession.isLoading ||
        activitiesLiveStatus.isLoading;

    const isEnabled = isEngagementAppEnabled(
        session,
        virtualSession,
        activitiesLiveStatus,
        isWaitingRoomActive
    );

    useEnabledAppTools(BuildInAppToolId.SessionExtension, isEnabled);

    return children({ isLoading, isEnabled });
};

export default EngagementAppEnabled;
